export function formatDateWithoutSeconds(inputDate, withTimezone) {
    if (!inputDate) return "";

    // Ajoute un timezone UTC si absent
    const normalizedDate = inputDate.endsWith("Z") || inputDate.includes("+") ? inputDate: inputDate + "Z";

    const date = new Date(normalizedDate);

    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");

    return `${day} ${date.toLocaleString('en-EU', { month: 'short' })} ${date.getUTCFullYear()}, ${hours}:${minutes}`;
}